/**
 * formatPhone - Auto-formats a phone number string into (###) ###-#### format.
 *
 * Strips all non-digit characters, then applies formatting progressively
 * as the user types. Used as an onChange handler for phone input fields.
 *
 * @param value - Raw input string (may contain digits, parens, dashes, spaces)
 * @returns Formatted phone string: "(###) ###-####" for 10 digits
 *
 * @example
 * formatPhone('614')		  // '(614'
 * formatPhone('6147074')	  // '(614) 707-4'
 * formatPhone('6147074445')  // '(614) 707-4445'
 */
export const formatPhone = (value: string): string => {
	// Strip everything except digits
	const digits = value.replace(/\D/g, '');

	// Limit to 10 digits (US phone number)
	const limited = digits.slice(0, 10);

	// Apply progressive formatting based on how many digits entered
	if (limited.length === 0) return '';
	if (limited.length <= 3) return `(${limited}`;
	if (limited.length <= 6) return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
	return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
};
